import request from '@/utils/request';
const baseInvoice = process.env.VUE_APP_INVOICE;
const baseURLAdmin = process.env.VUE_APP_ADMIN; // admin

// mdfe分页查询
export const getMDfePage = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/mdfePage',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取公司选项
export const getCompanyOptions = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/companyPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取司机分页信息
export const getDriverPage = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/driverPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据车牌号获取车辆信息
export const getCarInfoByPlateNumber = (data) => {
  return request({
    method: 'get',
    url: '/invoice/mdfe/getCarByLicensePlate?licensePlate=' + data,
    baseURL: baseURLAdmin
  });
};
// 校验车签号
export const checkCarSign = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/checkVtag',
    data,
    baseURL: baseInvoice
  });
};
// 取消MDFE
export const cancelMdfe = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/cancel',
    data,
    baseURL: baseInvoice
  });
};
// 生成MDFE
export const createMdfe = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/generate',
    data,
    baseURL: baseInvoice
  });
};
// 关闭MDFE
export const closeMdfeApi = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/close',
    data,
    baseURL: baseInvoice
  });
};
// 根据mdfe查询关联的cte
export const getCteByMdfe = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getCteByMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 通过mdfe查询关联司机
export const getDriverByMdfe = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getDriverByMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 解析mdfe xml 信息
export const parseMdfeXml = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取cte发票分页数据
export const getCteInvoicePage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 导出CTE发票
export const exportCteInvoice = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据CTE发票密钥获取CTE发票信息
export const getCteInvoiceByKey = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/getCteByInvoiceKeys',
    data,
    baseURL: baseURLAdmin
  });
};
// 按业务单号或发票号导出
export const exportCteInvoiceByNumbers = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/exportByNumbers',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 获取中途州省信息
const baseURL1 = process.env.VUE_APP_ADDRESS;
export const getMidProvince = (data) => {
  return request({
    method: 'get',
    url: '/addressSelector/v1/states?countryCode=076',
    data,
    baseURL: baseURL1
  });
};
// 通过州获取城市
export const getMidCity = (data) => {
  return request({
    method: 'get',
    url: '/addressSelector/v1/getCityListByState/' + data,
    baseURL: baseURL1
  });
};
// MDFE操作日志
export const getMdfeOperationLog = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfeLog/mdfeLogPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 取消cte发票
import requestZipCode from '@/utils/zipcodeRequest';
export const cancelCteInvoice = (data, isBool = true) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/cancel',
    data,
    baseURL: baseInvoice,
    isLoading: isBool
  });
};
// 补开cte发票
export const reopenCteInvoice = (data, isBool = true) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/supplement',
    data,
    baseURL: baseInvoice,
    isLoading: isBool
  });
};
// CTE绑定批单号失败分页
export const getCteBindBatchFailPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteBindAverError/page',
    data,
    baseURL: baseURLAdmin
  });
};
// CTE绑定批单号
export const bindCteBatch = (data) => {
  return request({
    method: 'post',
    url: '/cte/bindAver',
    data,
    baseURL: baseInvoice
  });
};
// 强制关闭
export const forceCloseCteInvoice = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/forceClose',
    data,
    baseURL: baseInvoice
  });
};
// CTE自动创建失败分页
export const getCteAutoCreateFailPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteErrorLog/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 下载cte xml
export const downloadCteXml = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cte/getCteXmlByInvoiceKey/' + data,
    data,
    baseURL: baseURLAdmin
  });
};
// 重新生成cte
export const reGenerateCte = (data) => {
  return request({
    method: 'get',
    url: '/cte/cteMqErrorLogHandle?id=' + data,
    baseURL: baseInvoice
  });
};
// 导出NFSe发票
export const exportNFSeInvoiceApi = (data) => {
  return request({
    method: 'post',
    url: '/invoice/NFSe/exportAll',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 新开CTE发票
export const newOpenCteInvoice = (data) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/generate',
    data,
    baseURL: baseInvoice
  });
};
// cnpj 查询
export const getCnpjInfo = (data) => {
  return request({
    method: 'post',
    data,
    url: '/invoice/cnpj/pageQuery',
    baseURL: baseURLAdmin
  });
};
// 更新cnpj信息
export const updateCnpjInfo = (data) => {
  return request({
    method: 'post',
    data,
    url: '/invoice/cnpj/updateCnpjInfo',
    baseURL: baseURLAdmin
  });
};
// 获取最新信息
export const getNewestCnpjInfo = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cnpj/gainLatestInfo/' + data,
    baseURL: baseURLAdmin
  });
};
// 下载xml
export const downloadXmlApi = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getMdfeXmlUrlByMdfeKey/' + data,
    data,
    baseURL: baseURLAdmin
  });
};
// nfse数据核对-快递-分页查询
export const getNfseDataCheckPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/receivingInvoices/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// nfse数据核对-揽收-分页查询
export const getNfseCollectCheckPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/collectOrderInvoice/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 快递订单数据推送批量导出
export const exportNfseDataCheck = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteErrorLog/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取CTE开票日历趋势图
export const getCteInvoiceTrend = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cte/dayCount?month=' + data,
    baseURL: baseURLAdmin
  });
};
// 批量导入重新生成
export const batchReGenerate = (data) => {
  return request({
    method: 'post',
    url: '/cte/importExcelHandle',
    data,
    baseURL: baseInvoice,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 剔除重复包裹记录-分页查询
export const getRepeatPackagePage = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRemoveRecord/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 剔除重复包裹记录-导出
export const exportRepeatPackage = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRemoveRecord/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 车签号校验
export const checkTagNumber = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/checkVtagForRemoveBag',
    data,
    baseURL: baseInvoice
  });
};
// 查询重复数据列表
export const getRepeatPackageList = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/listRepeatPackage',
    data,
    baseURL: baseInvoice
  });
};
// 剔除重复包裹记录
export const removeRepeatPackage = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/removeVTagRepeatPackage',
    data,
    baseURL: baseInvoice
  });
};
// 重复率查询
export const getRepeatRate = () => {
  return request({
    method: 'get',
    url: '/tagBagRepeatRateSet/getOne',
    baseURL: baseInvoice
  });
};
// 修改重复率
export const updateRepeatRate = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRepeatRateSet/add',
    data,
    baseURL: baseInvoice
  });
};
// 获取批量下载CTE发票信息
export const getBatchDownloadCteInvoiceInfo = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/getCteBatchDownload',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常处理MDFE
export const handleMdfeException = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/abnormalMdfeHand',
    data,
    baseURL: baseInvoice
  });
};
// 客户开票主体配置--分页查询
export const getInvoiceSubjectPage = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfo/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--新增或者编辑
export const addOrUpdateInvoiceSubject = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfo/saveOrUpdate',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--导出
export const exportInvoiceSubject = (data) => {
  return request({
    method: 'post',
    url: '/invoiceFormConfig/export',
    data,
    baseURL: baseInvoice
  });
};
// 客户开票主体配置操作日志--导出
export const exportInvoiceSubjectLog = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfoOperateLog/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--操作日志分页查询
export const getInvoiceSubjectLogPage = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfoOperateLog/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--启用/禁用
export const enableInvoiceSubject = (data) => {
  return request({
    method: 'get',
    url: '/cteCustomerBasicInfo/updateStatus?id=' + data.id + '&status=' + data.status,
    baseURL: baseURLAdmin
  });
};
// 获取客户开票主体配置详情
export const getInvoiceSubjectDetail = (data) => {
  return request({
    method: 'get',
    url: '/cteCustomerBasicInfo/getById?id=' + data,
    baseURL: baseURLAdmin
  });
};
// 通过cnpj、州二字码获取相关信息
export const getInvoiceSubjectByCnpj = (data) => {
  return request({
    method: 'post',
    url: '/cte/getIeByCnpj',
    data,
    baseURL: baseInvoice
  });
};
// 通过邮编获取地址信息
export const getAddressByZipCode = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cep/getCepInfo',
    data,
    baseURL: baseURLAdmin
  });
};
// mdfe批量导出
export const exportMdfeBatch = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 新客户开票主体配置--分页查询
export const getNewInvoiceSubjectPage = (data) => {
  return request({
    method: 'post',
    url: '/invoiceFormConfig/page',
    data,
    baseURL: baseInvoice
  });
};
// 获取新客户开票主体配置表单字段
export const getNewInvoiceSubjectForm = () => {
  return request({
    method: 'get',
    url: '/cte/getInvFormConfig',
    baseURL: baseInvoice
  });
};
// 添加、编辑新客户开票主体配置
export const addOrUpdateNewInvoiceSubject = (data) => {
  return request({
    method: 'post',
    url: '/invoiceFormConfig/saveOrUpdate',
    data,
    baseURL: baseInvoice
  });
};
// 新客户开票主体配置--启用、禁用
export const deleteNewInvoiceSubject = (data) => {
  return request({
    method: 'get',
    url: '/invoiceFormConfig/updateStatus?id=' + data.id + '&status=' + data.status,
    baseURL: baseInvoice
  });
};
// 保险服务分页
export const getInsuranceServicePage = (data) => {
  return request({
    method: 'post',
    url: '/insuranceConfig/page',
    data,
    baseURL: baseInvoice
  });
};
// 新增保险服务
export const addInsuranceService = (data) => {
  return request({
    method: 'post',
    url: '/insuranceConfig/add',
    data,
    baseURL: baseInvoice
  });
};
// 保险配置更新校验
export const insuranceServiceUpdateCheck = (data) => {
  return request({
    method: 'post',
    url: '/insuranceConfig/checkEdit',
    data,
    baseURL: baseInvoice
  });
};
// 保险配置更新确认
export const insuranceServiceUpdateConfirm = (data) => {
  return request({
    method: 'post',
    url: '/insuranceConfig/edit',
    data,
    baseURL: baseInvoice
  });
};
// 批量下载xml
export const batchDownloadXml = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/getCteXmlBatchDownload',
    data,
    baseURL: baseURLAdmin
  });
};
// cte归档批量下载xml
export const batchDownloadArchiveXml = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archiveGetCteXmlBatchDownload',
    data,
    baseURL: baseURLAdmin
  });
};
// 下载归档cte xml
export const downloadArchiveCteXml = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cteArchive/archiveGetCteXmlByInvoiceKey/' + data,
    data,
    baseURL: baseURLAdmin
  });
};
// 导出归档CTE发票
export const exportArchiveCteInvoice = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archiveExportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取批量下载归档CTE发票信息
export const getBatchDownloadArchiveCteInvoiceInfo = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archiveGetCteBatchDownload',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据CTE发票密钥获取归档CTE发票信息
export const getCteArchiveInvoiceByKey = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archiveGetCteByInvoiceKeys',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取归档cte发票分页数据
export const getCteArchiveInvoicePage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archivePageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 按业务单号或发票号导出归档信息
export const exportArchiveCteInvoiceByNumbers = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteArchive/archiveExportByNumbers',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 获取CTE开票日历趋势图归档数据归档
export const getCteInvoiceTrendArchive = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cteArchive/archiveDayCount?month=' + data,
    baseURL: baseURLAdmin
  });
};
// 获取CTE开票异常统计数据
export const getCteInvoiceException = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteErrorLog/statistics',
    data,
    baseURL: baseURLAdmin
  });
};
// 按客户导出CTE开票
export const exportCteInvoiceByCustomer = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/exportByCustomerId',
    data,
    baseURL: baseURLAdmin
  });
};
// 航空推送配置分页查询
export const airlinePushConfigPageQuery = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushConfig/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 新增航空推送配置
export const airlinePushConfigAdd = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushConfig/add',
    data,
    baseURL: baseURLAdmin
  });
};
// 查看航空推送配置详情
export const airlinePushConfigDetail = (data) => {
  return request({
    method: 'get',
    url: `/invoice/airlinePushConfig/detail/${data}`,
    baseURL: baseURLAdmin
  });
};
// 启用、禁用航空推送配置
export const airlinePushConfigUpdateStatus = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushConfig/updateStatus',
    data,
    baseURL: baseURLAdmin
  });
};
// 编辑航空推送配置
export const airlinePushConfigUpdate = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushConfig/update',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询航空推送记录
export const airlinePushRecordPageQuery = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushRecord/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询航空公司选项
export const airlinePushConfigPageQueryOptions = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushConfig/pageQueryOptions',
    data,
    baseURL: baseURLAdmin,
    isLoading: false
  });
};
// 新增航空公司推送记录
export const airlinePushRecordAdd = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushRecord/add',
    data,
    baseURL: baseURLAdmin
  });
};
// 批量导入推送记录
export const airlinePushRecordBatchImport = (data) => {
  return request({
    method: 'post',
    url: '/invoice/airlinePushRecord/batchImport',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询机场
export const airlineCargoUnits = (data) => {
  return request({
    method: 'post',
    url: '/airline/cargoUnits',
    data,
    baseURL: baseInvoice
  });
};
// 航空推送
export const airlinePush = (data) => {
  return request({
    method: 'post',
    url: '/airline/push',
    data,
    baseURL: baseInvoice
  });
};
// 重新推送
export const airlineRetryPush = (data) => {
  return request({
    method: 'post',
    url: '/airline/retryPush',
    data,
    baseURL: baseInvoice
  });
};
// 取消推送
export const airlineCancelPush = (data) => {
  return request({
    method: 'post',
    url: '/airline/cancelPush',
    data,
    baseURL: baseInvoice
  });
};
// 分页查询cte操作日志
export const getOperateLogPage = (data) => {
  return request({
    method: 'post',
    url: '/cte/operateLog/page',
    data,
    baseURL: baseURLAdmin
  });
};
// cte操作日志导出
export const getOperateLogExport = (data) => {
  return request({
    method: 'post',
    url: '/cte/operateLog/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 开票主体状态监控与告警-状态看板-KPI
export const getInvoiceSubjectStatusMonitor = (data) => {
  return request({
    method: 'get',
    url: '/monitor/dashboard/summary',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-状态看板-巴西地图
export const getInvoiceSubjectStatusMonitorBrazil = (data) => {
  return request({
    method: 'get',
    url: '/monitor/dashboard/map',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-状态看板-异常主体清单
export const getInvoiceSubjectStatusMonitorException = (data) => {
  return request({
    method: 'get',
    url: '/monitor/dashboard/anomalies',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-状态看板-告警时间线
export const getInvoiceSubjectStatusMonitorTimeline = (data) => {
  return request({
    method: 'get',
    url: '/monitor/dashboard/timeline',
    data,
    baseURL: baseInvoice
  });
};

// 开票主体状态监控与告警-IE信息管理分页查询
export const getInvoiceSubjectStatusMonitorIE = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/page',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-查询主体详情
export const getInvoiceSubjectStatusMonitorIEDetail = (data) => {
  return request({
    method: 'get',
    url: '/monitor/ie/detail?id=' + data,
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-新增IE主体
export const getInvoiceSubjectStatusMonitorIEAdd = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/add',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-编辑IE主体
export const getInvoiceSubjectStatusMonitorIEUpdate = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/edit',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-启用禁用
export const getInvoiceSubjectStatusMonitorIEUpdateStatus = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/toggle?id=' + data.id + '&enable=' + data.enable,
    // data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-维护系统配置状态
export const getInvoiceSubjectStatusMonitorIEUpdateSystemStatus = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/inspectSys?id=' + data.id + '&sysStatus=' + data.sysStatus,
    // data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-端点 10：单条检查（手动）
export const getInvoiceSubjectStatusMonitorIECheck = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/check?id=' + data.id,
    // data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-批量检查
export const getInvoiceSubjectStatusMonitorIEBatchCheck = () => {
  return request({
    method: 'post',
    url: '/monitor/ie/checkAll',
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-IE信息管理-导出
export const getInvoiceSubjectStatusMonitorIEExport = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ie/export',
    data,
    baseURL: baseInvoice
  });
};

// 开票主体状态监控与告警-告警配置-告警接收人列表
export const getInvoiceSubjectStatusMonitorRecipientList = () => {
  return request({
    method: 'get',
    url: '/monitor/recipient/list',
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警接收人新增/编辑
export const getInvoiceSubjectStatusMonitorRecipientSave = (data) => {
  return request({
    method: 'post',
    url: '/monitor/recipient/save',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警接收人启用/停用
export const getInvoiceSubjectStatusMonitorRecipientUpdateStatus = (data) => {
  return request({
    method: 'post',
    url: '/monitor/recipient/toggle?id=' + data.id + '&enable=' + data.enable,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警接收人删除
export const getInvoiceSubjectStatusMonitorRecipientDelete = (data) => {
  return request({
    method: 'post',
    url: '/monitor/recipient/delete?id=' + data.id,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警文案模板列表
export const getInvoiceSubjectStatusMonitorTemplateList = () => {
  return request({
    method: 'get',
    url: '/monitor/template/list',
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-编辑保存告警文案
export const getInvoiceSubjectStatusMonitorTemplateSave = (data) => {
  return request({
    method: 'post',
    url: '/monitor/template/save',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警文案测试推送
export const getInvoiceSubjectStatusMonitorTemplateTestPush = (data) => {
  return request({
    method: 'post',
    url: '/monitor/template/test?alertType=' + data.alertType + '&recipientId=' + data.recipientId,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-监控州范围列表
export const getInvoiceSubjectStatusMonitorStateList = (data) => {
  return request({
    method: 'get',
    url: '/monitor/ufs/list',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-批量更新州是否纳入监控
export const getInvoiceSubjectStatusMonitorStateUpdate = (data) => {
  return request({
    method: 'post',
    url: '/monitor/ufs/updateStatus',
    data,
    baseURL: baseInvoice
  });
};
// 开票主体状态监控与告警-告警配置-告警配置变更日志
export const getInvoiceSubjectIeConfigChangePage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieConfigChangePage',
    data,
    baseURL: baseURLAdmin
  });
};

// 开票主体状态监控与告警-变更日志-变更日志列表
export const getInvoiceSubjectStatusMonitorLogList = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieChangePage',
    data,
    baseURL: baseURLAdmin
  });
};
// 开票主体状态监控与告警-变更日志-变更日志导出
export const getInvoiceSubjectStatusMonitorLogExport = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieChangeExport',
    data,
    baseURL: baseURLAdmin
  });
};

// 开票主体状态监控与告警-告警日志-告警日志列表
export const getInvoiceSubjectStatusMonitorAlarmLogList = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieAlertPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 开票主体状态监控与告警-告警日志-告警日志导出
export const getInvoiceSubjectStatusMonitorAlarmLogExport = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieAlertExport',
    data,
    baseURL: baseURLAdmin
  });
};
// 开票主体状态监控与告警-告警配置变更日志-分页查询
export const getInvoiceSubjectStatusMonitorConfigLogList = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cls/logs/ieConfigPage',
    data,
    baseURL: baseURLAdmin
  });
};
